import { useMergeRefs } from '@floating-ui/react';
import React from 'react';

import { useTooltipState } from './tooltip-context';

/**
 * Returns a clone of the child element with necessary props added to enable tooltip to be triggered
 * when hovering the child element.
 */
const TooltipTrigger = React.forwardRef<HTMLElement, React.HTMLProps<HTMLElement>>(
  function TooltipTrigger({ children, ...props }, propRef) {
    const state = useTooltipState();
    const ref = useMergeRefs([state.refs.setReference, propRef]);

    return React.isValidElement(children)
      ? React.cloneElement(
          children,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          state.getReferenceProps({
            ref,
            ...props,
            ...children.props,
          }),
        )
      : null;
  },
);

export { TooltipTrigger };
